"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var canvas_1 = __importDefault(require("./canvas"));
var state_1 = __importDefault(require("./state"));
var Frame_1 = __importDefault(require("./controllers/Frame"));
var Zoom_1 = __importDefault(require("./controllers/Zoom"));
var History_1 = __importDefault(require("./controllers/History"));
var Objects_1 = __importDefault(require("./controllers/Objects"));
var Events_1 = __importDefault(require("./controllers/Events"));
var event_manager_1 = __importDefault(require("./event-manager"));
var Scene_1 = __importDefault(require("./controllers/Scene"));
var Renderer_1 = __importDefault(require("./controllers/Renderer"));
var Personalization_1 = __importDefault(require("./controllers/Personalization"));
var constants_1 = require("./common/constants");
var Guidelines_1 = __importDefault(require("./controllers/Guidelines"));
var BleedGuides_1 = __importDefault(require("./controllers/BleedGuides"));
var SafeZone_1 = __importDefault(require("./controllers/SafeZone"));
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor(_a) {
        var id = _a.id, state = _a.state, config = _a.config;
        var _this = _super.call(this) || this;
        _this.initializeCanvas = function () {
            var canvas = new canvas_1.default({
                id: _this.canvasId,
                config: _this.config,
                editor: _this,
            });
            _this.canvas = canvas;
        };
        _this.initializeControllers = function () {
            var options = {
                canvas: _this.canvas.canvas,
                editor: _this,
                config: _this.config,
                state: _this.state,
            };
            _this.frame = new Frame_1.default(options);
            _this.zoom = new Zoom_1.default(options);
            _this.history = new History_1.default(options);
            _this.objects = new Objects_1.default(options);
            _this.safeZone = new SafeZone_1.default(options);
            _this.events = new Events_1.default(options);
            _this.personalization = new Personalization_1.default(options);
            _this.scene = new Scene_1.default(options);
            _this.guidelines = new Guidelines_1.default(options);
            _this.bleedGuides = new BleedGuides_1.default(options);
            _this.renderer = new Renderer_1.default();
        };
        // CONTEXT MENU
        _this.cancelContextMenuRequest = function () {
            _this.state.setContextMenuRequest(null);
        };
        _this.state = state ? state : new state_1.default();
        _this.config = __assign(__assign(__assign({}, constants_1.defaultEditorConfig), config), { id: id });
        _this.canvasId = id;
        _this.initializeCanvas();
        _this.initializeControllers();
        _this.state.setEditor(_this);
        return _this;
    }
    Editor.prototype.debug = function () {
        console.log({
            objects: this.canvas.canvas.getObjects(),
            json: this.canvas.canvas.toJSON(),
        });
    };
    Editor.prototype.destroy = function () {
        this.canvas.destroy();
    };
    return Editor;
}(event_manager_1.default));
exports.Editor = Editor;
//# sourceMappingURL=editor.js.map